import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

const categoryLabels: Record<string, string> = {
  'ru-men-jiao-cheng': '入门教程',
  'yan-zou-ji-qiao': '演奏技巧',
  'xuan-gou-zhi-nan': '选购指南',
  'pin-pai-dui-bi': '品牌对比',
  'li-shi-qi-yuan': '历史起源',
  'wei-hu-bao-yang': '维护保养',
};

const articleImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=A%20hexagonal%20traditional%20Chinese%20string%20instrument%20liujiaoqin%20displayed%20on%20a%20warm%20wooden%20stand%20with%20soft%20natural%20lighting%20minimalist%20studio%20cream%20background%20elegant&width=800&height=500&seq=art-detail-1&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Close-up%20hands%20holding%20bamboo%20mallets%20over%20hexagonal%20instrument%20demonstrating%20grip%20technique%20soft%20light%20cream%20background%20educational&width=800&height=500&seq=art-detail-2&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Student%20at%20hexagonal%20instrument%20sheet%20music%20metronome%20warm%20afternoon%20light%20cozy%20home%20practice%20cream%20walls%20natural&width=800&height=500&seq=art-detail-3&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Young%20child%20small%20hexagonal%20instrument%20smiling%20parent%20bright%20home%20soft%20lighting%20cream%20wood%20tones%20heartwarming&width=800&height=500&seq=art-detail-4&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Professional%20musician%20hands%20playing%20hexagonal%20instrument%20dynamic%20action%20dramatic%20side%20lighting%20dark%20warm%20background%20artistic&width=800&height=500&seq=art-detail-5&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Array%20mallets%20beaters%20beside%20hexagonal%20instrument%20various%20materials%20warm%20studio%20lighting%20shallow%20depth%20professional&width=800&height=500&seq=art-detail-6&orientation=landscape',
  7: 'https://readdy.ai/api/search-image?query=Hexagonal%20instrument%20sheet%20music%20stand%20traditional%20notation%20warm%20desk%20lamp%20intimate%20practice%20room%20cream%20walls%20cultural&width=800&height=500&seq=art-detail-7&orientation=landscape',
  8: 'https://readdy.ai/api/search-image?query=Musical%20theory%20diagram%20overlaying%20hexagonal%20instrument%20double%20exposure%20warm%20amber%20cream%20tones%20artistic%20educational&width=800&height=500&seq=art-detail-8&orientation=landscape',
  9: 'https://readdy.ai/api/search-image?query=Multiple%20hexagonal%20instruments%20different%20sizes%20wood%20finishes%20wooden%20rack%20instrument%20shop%20natural%20light%20cream%20walls%20elegant&width=800&height=500&seq=art-detail-9&orientation=landscape',
  10: 'https://readdy.ai/api/search-image?query=Entry-level%20hexagonal%20instrument%20price%20tag%20clean%20background%20music%20store%20natural%20wood%20bright%20commercial&width=800&height=500&seq=art-detail-10&orientation=landscape',
  11: 'https://readdy.ai/api/search-image?query=Premium%20handcrafted%20hexagonal%20instrument%20exquisite%20wood%20grain%20detailed%20golden%20lighting%20studio%20dark%20background%20luxury&width=800&height=500&seq=art-detail-11&orientation=landscape',
  12: 'https://readdy.ai/api/search-image?query=Pre-owned%20hexagonal%20instrument%20patina%20showing%20character%20cozy%20vintage%20music%20room%20warm%20light%20authentic&width=800&height=500&seq=art-detail-12&orientation=landscape',
  13: 'https://readdy.ai/api/search-image?query=Collection%20hexagonal%20instruments%20various%20brands%20gallery%20display%20professional%20lighting%20museum-quality%20cream%20background&width=800&height=500&seq=art-detail-13&orientation=landscape',
  14: 'https://readdy.ai/api/search-image?query=Two%20hexagonal%20instruments%20side%20by%20side%20classic%20modern%20finish%20studio%20comparison%20neutral%20lighting%20clean&width=800&height=500&seq=art-detail-14&orientation=landscape',
  15: 'https://readdy.ai/api/search-image?query=Master%20craftsman%20hands%20hexagonal%20instrument%20traditional%20workshop%20wood%20shavings%20golden%20light%20artisanal%20textures&width=800&height=500&seq=art-detail-15&orientation=landscape',
  16: 'https://readdy.ai/api/search-image?query=Hexagonal%20instrument%20Chinese%20international%20design%20world%20map%20background%20fusion%20warm%20professional%20lighting%20sophisticated&width=800&height=500&seq=art-detail-16&orientation=landscape',
  17: 'https://readdy.ai/api/search-image?query=Antique%20hexagonal%20instrument%20Ming-Qing%20dynasty%20museum%20aged%20wood%20historical%20soft%20lighting%20cultural%20heritage%20elegant&width=800&height=500&seq=art-detail-17&orientation=landscape',
  18: 'https://readdy.ai/api/search-image?query=Elderly%20master%20musician%20hexagonal%20instrument%20traditional%20Chinese%20attire%20stage%20lighting%20heritage%20respectful&width=800&height=500&seq=art-detail-18&orientation=landscape',
  19: 'https://readdy.ai/api/search-image?query=Traditional%20instrument%20workshop%20craftsman%20carving%20hexagonal%20instrument%20tools%20warm%20lighting%20artisanal%20documentary&width=800&height=500&seq=art-detail-19&orientation=landscape',
  20: 'https://readdy.ai/api/search-image?query=Portrait%20distinguished%20Chinese%20musician%20hexagonal%20instrument%20vintage%20sepia%20tones%20historical%20documentary%20cultural&width=800&height=500&seq=art-detail-20&orientation=landscape',
  21: 'https://readdy.ai/api/search-image?query=Hexagonal%20instrument%20being%20cleaned%20soft%20cloth%20caring%20hands%20close-up%20bright%20studio%20lighting%20maintenance%20fresh&width=800&height=500&seq=art-detail-21&orientation=landscape',
  22: 'https://readdy.ai/api/search-image?query=Digital%20tuner%20clipped%20hexagonal%20instrument%20display%20tuned%20note%20warm%20lighting%20educational%20clean%20precise&width=800&height=500&seq=art-detail-22&orientation=landscape',
  23: 'https://readdy.ai/api/search-image?query=Hands%20changing%20strings%20hexagonal%20instrument%20new%20strings%20installed%20wooden%20workbench%20bright%20lighting%20DIY%20practical&width=800&height=500&seq=art-detail-23&orientation=landscape',
  24: 'https://readdy.ai/api/search-image?query=Hexagonal%20instrument%20section%20highlighted%20issue%20area%20diagnostic%20clear%20educational%20warm%20workshop%20lighting%20problem-solving&width=800&height=500&seq=art-detail-24&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen pt-16">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900">文章未找到</h1>
            <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.category === article.category && a.id !== article.id)
    .slice(0, 3);

  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="Article"
        data={{
          headline: article.title,
          description: article.excerpt,
          author: article.author,
          datePublished: article.date,
          dateModified: article.date,
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: `${article.title} - 六角琴专业指南`,
          description: article.excerpt,
          url: `https://www.liujiaoqin.com/article/${slug}`,
        }}
      />
      <Navbar />
      <main className="min-h-screen pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: categoryLabels[article.category], href: `/category/${article.category}` },
            { label: article.title },
          ]}
        />

        <article className="w-full px-4 md:px-6 py-8 md:py-10 bg-background-50">
          <div className="max-w-3xl mx-auto">
            <div className="mb-6">
              <span className="inline-block text-xs font-medium text-primary-500 bg-primary-100 px-3 py-1 rounded-full mb-4">
                {categoryLabels[article.category]}
              </span>
              <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 leading-tight">
                {article.title}
              </h1>
              <div className="flex items-center gap-4 mt-3 text-sm text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line w-4 h-4 flex items-center justify-center"></i>
                  {article.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
                  {article.date}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i>
                  {article.readTime}
                </span>
              </div>
            </div>

            <div className="rounded-lg overflow-hidden mb-8">
              <img
                src={articleImages[article.id] || articleImages[1]}
                alt={article.title}
                title={article.title}
                className="w-full h-auto max-h-[450px] object-cover object-top"
              />
            </div>

            <div
              className="prose prose-sm md:prose-base max-w-none
                prose-headings:font-heading prose-headings:text-foreground-900 prose-headings:font-semibold
                prose-h2:text-xl prose-h3:text-lg prose-h4:text-base
                prose-p:text-foreground-600 prose-p:leading-relaxed
                prose-strong:text-foreground-900
                prose-a:text-primary-500 prose-a:no-underline hover:prose-a:text-primary-600
                prose-li:text-foreground-600
                [&_h3]:mt-8 [&_h3]:mb-3 [&_p]:mb-4 [&_p]:mt-0"
              dangerouslySetInnerHTML={{ __html: article.contentHtml }}
            />

            <div className="mt-10 pt-8 border-t border-background-200/70">
              <div className="flex flex-wrap items-center gap-3 text-sm text-foreground-500">
                <span>标签：</span>
                <span className="bg-background-100 px-3 py-1 rounded text-xs">{categoryLabels[article.category]}</span>
                <span className="bg-background-100 px-3 py-1 rounded text-xs">六角琴</span>
              </div>
            </div>
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-6">
                相关文章
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.slug}`}
                    className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
                  >
                    <div className="h-36 w-full overflow-hidden">
                      <img
                        src={articleImages[ra.id] || articleImages[1]}
                        alt={ra.title}
                        title={ra.title}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-3">
                      <h3 className="font-heading text-xs md:text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
                        {ra.title}
                      </h3>
                      <span className="text-xs text-foreground-400 mt-1">{ra.readTime}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </>
  );
}